var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoHamburger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "16px",
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 13") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop+Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Homepage-Mobile",
    transform: "translate(-342.000000, -72.000000)",
    fill: "#1676a7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 44.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(342.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0596528,7 L0.718125,7 C0.321527778,7 0,7.44768398 0,8 C0,8.55231602 0.321527778,9 0.718125,9 L17.0596528,9 C17.4562847,9 17.7777778,8.55231602 17.7777778,8 C17.7777778,7.44773233 17.4562847,7 17.0596528,7 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0596528,0 L0.718125,0 C0.321527778,0 0,0.447732328 0,1 C0,1.55226767 0.321527778,2 0.718125,2 L17.0596528,2 C17.4562847,2 17.7777778,1.55226767 17.7777778,1 C17.7777778,0.447732328 17.4562847,0 17.0596528,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0596528,14 L0.718125,14 C0.321527778,14 0,14.447684 0,15 C0,15.552316 0.321527778,16 0.718125,16 L17.0596528,16 C17.4562847,16 17.7777778,15.552316 17.7777778,15 C17.7777778,14.447684 17.4562847,14 17.0596528,14 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHamburger);
export default __webpack_public_path__ + "static/media/ico-hamburger.af5a2fba6ce7af769847cc3b2b908438.svg";
export { ForwardRef as ReactComponent };